import clsx from "clsx"
import { useLayoutEffect, useRef, useState } from "react"

import useUser from "@hooks/useUser"

import filterUserLinks from "@utils/filterUserLinks"

import NavSidebarItem from "@organisms/NavSidebar/components/NavSidebarItem/NavSidebarItem"

import styles from "./NavSidebarItemGroup.module.scss"
import { NavSidebarItemGroupProps } from "./NavSidebarItemGroup.types"

export default function NavSidebarItemGroup(props: NavSidebarItemGroupProps) {
    const { header, items, className, defaultOpen = false } = props
    const [isOpen, setIsOpen] = useState<boolean>(defaultOpen)
    const itemsRef = useRef<HTMLDivElement>(null)
    const [activeItem, setActiveItem] = useState<string | null>(null)

    const { user } = useUser()

    const toggleOpen = () => setIsOpen(!isOpen)

    const open = (itemLabel: string) => {
        if (activeItem !== itemLabel) {
            setActiveItem(itemLabel)
            setIsOpen(true)
        }
    }

    const [itemsStyle, setItemsStyle] = useState({})

    useLayoutEffect(() => {
        if (isOpen) {
            setItemsStyle({ maxHeight: itemsRef.current?.scrollHeight ?? 0 })
        } else {
            setItemsStyle({ maxHeight: 0 })
        }
    }, [isOpen])

    return (
        <div
            className={clsx(styles.base, className, {
                [styles.open]: isOpen,
            })}
        >
            <div className={styles.header}>
                <NavSidebarItem
                    label={header.label}
                    variant="groupHead"
                    onClick={toggleOpen}
                    isExpanded={isOpen}
                    icon={header.icon}
                    iconActive={header.iconActive}
                />
            </div>
            <div className={clsx(styles.items)} ref={itemsRef} style={itemsStyle}>
                {filterUserLinks(items, user).map((item) => (
                    <NavSidebarItem
                        key={item.path}
                        label={item.label}
                        path={item.path}
                        variant="groupItem"
                        isExpanded={isOpen}
                        onActive={open}
                        icon={item.icon}
                        iconActive={item.iconActive}
                    />
                ))}
            </div>
        </div>
    )
}
